// Databricks job trigger GraphQL query
export const TRIGGER_DBX_JOB_QUERY = `query TriggerDatabricksJob($request: JobTriggerRequestInput!) {
    TriggerDatabricksJob(request: $request) {
        success
        runId
        jobId
        status
        numberInJob
        errorMessage
    }
}`;